<template>
  <div
    class="ma-auto"
    :style="{ maxWidth: this.isSquare ? '150px' : 'min(350px, 60%)' }"
  >
    <btn-layout :item="item" />
  </div>
</template>

<script>
import BtnLayout from './BtnLayout'
export default {
  name: 'BtnBig',
  components: { BtnLayout },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    isSquare () {
      return this.item.itemableAttributes.type === 'square'
    }
  }
}
</script>
